import { LoadingPageTemplate } from '@/components/client/Templates/LoadingPageTemplate';

export default LoadingPageTemplate;
